import { render, staticRenderFns } from "./admin_manage_users.vue?vue&type=template&id=0dc70664&scoped=true&"
import script from "./admin_manage_users.vue?vue&type=script&lang=js&"
export * from "./admin_manage_users.vue?vue&type=script&lang=js&"
import style0 from "./admin_manage_users.vue?vue&type=style&index=0&id=0dc70664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc70664",
  null
  
)

export default component.exports